$(function () {
  // Check if map exists
  if($('#cow')) {
    // Loop through each AREA in the imagemap

    $('#cow area').each(function() {

        var cuts_id = $(this).attr('id').replace('area_', '');
        $('#'+cuts_id+'_box').hide();

        //console.log(cuts_id);

        $(this).bind("mouseover", function(e) {
	        var cuts_id = $(this).attr('id').replace('area_', '');

            if (!$('#'+cuts_id).hasClass('selected')) {
                $('#'+cuts_id).show();
            }

            //mouseover name

            if (!$('#'+cuts_id+'_name').hasClass('active')) {
	        	$('#'+cuts_id+'_name').addClass('temp-active');
	        }

            e.preventDefault();
        });

        // Assigning an action to the mouseout event

        $(this).bind("mouseout", function(e) {
	        var cuts_name = $(this).attr('id').replace('_name', '');

            if (!$('#'+cuts_id).hasClass('selected')) {
	            $('#'+cuts_id).hide();
            }

            //mouseout name

            if (!$('#'+cuts_id+'_name').hasClass('active')) {
	        	$('#'+cuts_id+'_name').removeClass('temp-active');
	        	$('#'+cuts_id+'_name').siblings().removeClass('temp-active');
	        }
            e.preventDefault();
        });


        // Assigning an action to the click event
        $(this).click(function(e) {

	        var cuts_id = $(this).attr('id').replace('area_', '');

			// stay selected cut
            if ($('#'+cuts_id).hasClass('selected')) {
                $('#'+cuts_id).removeClass('selected');
            } else {
                $('#'+cuts_id).addClass('selected');
            }

            //show & hide content
            $("#" + cuts_id +'_box').siblings().fadeOut("fast").hide();
            $("#" + cuts_id +'_box').fadeIn('slow');


			//siblings hide
			$('#'+ cuts_id).siblings().removeClass('selected');
			$('#'+ cuts_id).siblings().hide();


			//custom osobuco
			if(cuts_id === 'osobucoadelante'){
				//console.log(cuts_id);

				$('#osobuco_name').addClass('active');
				$('#osobuco_name').siblings().removeClass("active");

			//custom postarosada
			} else if(cuts_id === 'postarosada'){

				$('.postas').siblings().removeClass("active");
				$('.postas').addClass('active');

			// custom plateada
			} else if(cuts_id === 'plateada'){

				$('.asados').siblings().removeClass("active");
				$('.asados').addClass('active');

			// other cuts
			} else {
				$("#" + cuts_id +'_name').addClass('active');
				$("#" + cuts_id +'_name').siblings().removeClass("active");
			}

			e.preventDefault();

        });
    });


    $('#table-cow li').each(function() {

	    $(this).click(function(e) {
		    var cuts_id = $(this).attr('id').replace('_name', '');
		    var cuts_nameid = $(this).attr('id');
		    var cuts_nameclass = $(this).attr('class');


		     //console.log(cuts_nameclass);

		    if(cuts_nameid === 'osobuco_name'){
			    // remove siblings
			    $('#cow').find('.osobuco_cut').siblings().removeClass('selected');
			    $('#cow').find('.osobuco_cut').siblings().hide();

			    // add and show cut
			    $('#cow').find('.osobuco_cut').addClass('selected');
			    $('#cow').find('.osobuco_cut').show();

			    $(this).siblings().removeClass('active');
			    $(this).addClass('active');

		    } else if(cuts_nameid === 'plateada_name'){

		    	$('#cow').find('#plateada').siblings().removeClass('selected');
		    	$('#cow').find('#plateada').siblings().hide();

		    	$('#cow').find('#plateada').addClass('selected');
			    $('#cow').find('#plateada').show();

			    $(this).siblings().removeClass('active');
			    $(this).addClass('active');


		    } else if(cuts_nameid === 'postarosada_name'){

			    $('#cow').find('#postarosada').siblings().removeClass('selected');
			    $('#cow').find('#postarosada').siblings().hide();

		    	$('#cow').find('#postarosada').addClass('selected');
			    $('#cow').find('#postarosada').show();

			    $(this).siblings().removeClass('active');
			    $(this).addClass('active');

		    } else {

				// cut siblings remove and hide
		        $('#cow').find('#'+cuts_id).siblings().removeClass('selected');
		        $('#cow').find('#'+cuts_id).siblings().hide();

		        //name list siblings
		        $(this).siblings().removeClass('active');

		        // this cut add and show
	            $('#cow').find('#'+cuts_id).addClass('selected');
	            $('#cow').find('#'+cuts_id).show();

	             //name list
	            $(this).addClass('active');
            }

            //show & hide content
			$("#" + cuts_id +'_box').siblings().fadeOut("fast").hide();
            $("#" + cuts_id +'_box').fadeIn('slow');

			 e.preventDefault();
		});


	    $(this).bind("mouseover", function(e) {
		    var cuts_id = $(this).attr('id').replace('_name', '');

	  		if (!$('#'+cuts_id).hasClass('active') && !$('#cow').find('#'+cuts_id).hasClass('selected')) {
	  			$(this).addClass('active');
	  			$('#cow').find('#'+cuts_id).show();
	  		}
	  		e.preventDefault();
	    });


	     $(this).bind("mouseout", function(e) {
		    var cuts_id = $(this).attr('id').replace('_name', '');

	        if (!$('#'+cuts_id).hasClass('active') && !$('#cow').find('#'+cuts_id).hasClass('selected')) {
	        	$(this).removeClass('active');
	        	$('#cow').find('#'+cuts_id).hide();
	        }
	        e.preventDefault();
	    });


     });
  }

 // Check if ID exists
	if($('#pork')) {

		// Loop through each AREA in the imagemap
		$('#pork-svg a').each(function() {

				var cuts_id = $(this).attr('id').replace('area_', '');
				//var cuts_name = $(this).attr('id').replace('_name', '');

				$('#'+cuts_id+'_box').hide();

			// Assigning an action to the mouseover event
			$(this).mouseenter(function(e) {

				if (!$('#'+cuts_id).hasClass('selected')) {
				   $('#'+cuts_id).removeClass('selected');
	        	}

				 	//mouseenter name
	       	   if (!$('#'+cuts_id+'_name').hasClass('active')) {
		         $('#'+cuts_id+'_name').addClass('temp-active');
		      	}

				e.preventDefault();

			});

		    $(this).mouseleave(function(e) {

		        if (!$('#'+cuts_id).hasClass('selected')) {
		            $('#'+cuts_id).removeClass('selected');
		        }

		        //mouseleave name
		        if (!$('#'+cuts_id+'_name').hasClass('active')) {
		        	$('#'+cuts_id+'_name').removeClass('temp-active');
		        	$('#'+cuts_id+'_name').siblings().removeClass('temp-active');
		        }
		        e.preventDefault();

		      });

			  // Assigning an action to the click event
			  $(this).click(function(e) {

							var cuts_id = $(this).attr('id').replace('area_', '');

							// stay selected cut
							if ($('#'+cuts_id).hasClass('selected')) {
							  $('#'+cuts_id).attr('class', '');
							} else {
                              $('#'+cuts_id).attr("class", "selected").parent('g').siblings().find('a').attr('class', '');
                              
							}

							$("#" + cuts_id +'_name').addClass('active');
							$("#" + cuts_id +'_name').siblings().removeClass("active");

							//show & hide content
							$("#" + cuts_id +'_box').siblings().fadeOut("fast").hide();
							$("#" + cuts_id +'_box').fadeIn('slow');

							e.preventDefault();

		       });

		});

		$('#table-pork li').each(function() {

			$(this).click(function(e) {
                var cuts_id = $(this).attr('id').replace('_name', '');

				// cut siblings remove and hide
		        $('#pork-svg').find('#'+cuts_id).parent('g').siblings().find('a').attr('class', '');

		        //name list siblings
		        $(this).siblings().removeClass('active');
                $(this).siblings().removeClass('temp-active');

		        // this cut
                //console.log('#'+cuts_id);

	           //add selected and active
	           $(this).addClass('active');
               //$('#pork-svg').find('#'+cuts_id).addClass('selected');
               $('#pork-svg #'+cuts_id).attr("class", "selected");

	           //show & hide content
			   $("#" + cuts_id +'_box').siblings().fadeOut("fast").hide();
	           $("#" + cuts_id +'_box').fadeIn('slow');

				e.preventDefault();

			 });


			 $(this).mouseenter(function(e) {
			    var cuts_id = $(this).attr('id').replace('_name', '');

		  		if (!$(this).hasClass('active') && !$('#pork-svg').find('#'+cuts_id).hasClass('selected')) {
		  			$(this).addClass('temp-active');
		  			$('#pork-svg').find('#'+cuts_id).attr("class", "selected");
		  		}
		  		e.preventDefault();
		    });

		    $(this).mouseleave(function(e) {

			    var cuts_id = $(this).attr('id').replace('_name', '');

		        if (!$(this).hasClass('active')) {
					$(this).removeClass('temp-active');
					$('#pork-svg').find('#'+cuts_id).attr('class', '');
		        }
		        e.preventDefault();
		    });


		});
	} // end pork

	$('#menu-main .menu > li').bind('mouseover focus', openSubMenu);
	$('#menu-main .menu > li ul').bind('mouseover focus', openSubMenu);
	$('#menu-main .menu > li').bind('mouseout focus', closeSubMenu);

  sideBar();
});

function openSubMenu() {
   $(this).find('ul').css('visibility', 'visible');
};

function closeSubMenu() {
   $(this).find('ul').css('visibility', 'hidden');
};

function sideBar(){
      $('.submenu li.current').parents('li').addClass('current');
      if($('#sidebar > li').hasClass('current')){
        $('#shop-catalog > li.current').siblings('li').hide();
      }
    }
